import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import c from 'classnames';
import styles from './Search.css';
import { ItemKudos } from '../item/ItemKudos';
import { formatDateItemFooter } from '../../lib/helpers';

const SuggestedItem = ({ 
  item, 
  onSelect, 
  removeInput,
}) => (
  <div className={styles.item} onClick={() => {
    onSelect(item);
    removeInput();
  }} style={{ 'cursor': 'pointer'}}>
    <ItemSummary item={item} />
  </div>
);

const SelectedItem = ({ children }) => (
  <div className={c(styles.item, styles.item_selected )}>
    {children}
  </div>
);

const ItemSummary = ({ item }) => (
  <>
    <div className={styles.img_holder}>
      <img width="100px" height="100px" src={item.still} />
    </div>
    <div className={styles.description}>
      <h3 className="title">{item.title}</h3>
      <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
      <div className={styles.footer_summary}>
        <span>{formatDateItemFooter(item.date)}</span> 
        <span>
          kudos: <ItemKudos numOfKudos={item.stats.kudos_total} />
        </span>
      </div>
    </div>
  </>
);

export const AutoSuggestItem = ({ 
  item, 
  onSelect, 
  selected, 
  onRemove, 
  index, 
  removeInput,
}) => {
  return (
    <>
      {!selected && <SuggestedItem 
        item={item} 
        onSelect={onSelect} 
        removeInput={removeInput} 
      /> }
      {selected && (
        <SelectedItem item={item} onRemove={onRemove} index={index} >
          <a href={`/item/${item.id}`} rel="noopener noreferrer" target="_blank">
            <ItemSummary item={item} />
          </a>
          <div className={styles.options}>
            <div className={styles.number}>
              <span>
                {index + 1}
              </span>
            </div>
            <div className={styles.delete} onClick={() => onRemove(item.id)}>
              <span>
                <FontAwesomeIcon icon={['fas', 'times']} size="2x" />
              </span>
            </div>
          </div>          
        </SelectedItem>
      )}
    </>
  );
};